import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.174 6.392h3.204m-3.204 0V3.176m0 3.216 2.675-2.94a6.432 6.432 0 1 1-1.416 6.96m5.965-4.824v3.216l2.412 1.206" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }